import React, { useContext, useEffect, useState } from "react";

import "./stylesBetsTypesList.css";
import CustomDatePicker from "../../../../CommonComponents/CustomDatePicker/CustomDatePicker";

import dayjs from "dayjs";
import { Pagination, Select } from "antd";
import createPrivateAdminPanelInstance from "../../../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../../../api/ApiRoutes";
import RebetLoader from "../../../../CommonComponents/RebetLoader/RebetLoader";
import DragAndDropTable from "./DragAndDropTable/DragAndDropTable";
import { SIDER_TABS } from "../../../../../utils/Constants";
import { LeftOutlined } from "@ant-design/icons";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AppStrings } from "../../../../../utils/constants/AppStrings";
import { usePageTitle } from "../../../../CommonComponents/Layout/PageTitleContext";
import { getAdminNow } from "../../../../../utils/dateService";

const BetTypeDictionary = {
  Straight: 1,
  "Round Robin": 4,
  Group: 5,
};

const BetTypeDictionary2 = {
  1: "Straight",
  4: "Round Robin",
  5: "Group",
};

const initialColumnsState = [
  {
    title: "Provider",
    dataIndex: "odds_provider",
    key: "odds_provider",
    initialWidth: 150,
    columnIndex: 0,
  },
  {
    title: "CCF",
    dataIndex: "ccf_score",
    key: "ccf_score",
    initialWidth: 80,
    columnIndex: 1,
  },
  {
    title: "ID",
    dataIndex: "bet_id",
    key: "bet_id",
    initialWidth: 100,
    columnIndex: 2,
  },
  {
    title: "User ID",
    dataIndex: "user_id",
    key: "user_id",
    initialWidth: 100,
    columnIndex: 3,
  },
  {
    title: "Date",
    dataIndex: "date_time",
    key: "date_time",
    initialWidth: 150,
    columnIndex: 4,
  },
  {
    title: "Market",
    dataIndex: "market_names",
    key: "market_names",
    initialWidth: 200,
    columnIndex: 7,
  },
  {
    title: "Selection",
    dataIndex: "selection_names",
    key: "selection_names",
    initialWidth: 200,
    columnIndex: 8,
  },
  {
    title: "Odds",
    dataIndex: "odds",
    key: "odds",
    initialWidth: 200,
    columnIndex: 9,
  },
  {
    title: "Bet Type",
    dataIndex: "bet_type",
    key: "bet_type",
    initialWidth: 200,
    columnIndex: 10,
  },
  {
    title: "Live",
    dataIndex: "preMatchLive",
    key: "preMatchLive",
    initialWidth: 200,
    columnIndex: 11,
  },
  {
    title: "Bet Amount",
    dataIndex: "bet_amount",
    key: "bet_amount",
    initialWidth: 200,
    columnIndex: 12,
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    initialWidth: 200,
    columnIndex: 13,
  },
  {
    title: "Potential Payout",
    dataIndex: "payout",
    key: "payout",
    initialWidth: 200,
    columnIndex: 14,
  },
];

function BetsTypesList() {
  usePageTitle(AppStrings.BETS_TYPES_LIST);
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken,
    false
  );
  const columnsState =
    JSON.parse(localStorage.getItem("columnsStateEventDetailsBetsTypesList")) ||
    initialColumnsState;

  const todayRange = [getAdminNow(), getAdminNow()];
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const eventId = searchParams.get("event-id");
  const betType = searchParams.get("bet-type");

  const [isApiRunning, setIsApiRunning] = useState(false);
  const [sportsBookDates, setSportsBookDates] = useState(null);

  const [columns, setColumns] = useState(columnsState);

  const [selectedBetType, setSelectedBetType] = useState(betType);
  const [selectedBetId, setSelectedBetId] = useState(null);
  const [selectedMarketType, setSelectedMarketType] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);

  const [dataSource, setDataSource] = useState([]);
  const [betsToShowInTable, setBetsToShowInTable] = useState([]);
  const [pagination, setPagination] = useState({
    current_page: 1,
    page_size: 20,
    total_results: 0,
    total_pages: 0,
    has_next: false,
    has_prev: false,
  });
  const [betsCache, setBetsCache] = useState({});
  const [betTypes, setBetTypes] = useState([
    {
      value: "single",
      label: "Straight",
    },
    {
      value: "round_robin_leg",
      label: "Round Robin",
    },
    {
      value: "grouped_leg",
      label: "Group",
    },
    {
      value: "parlay",
      label: "Parlay",
    },
  ]);
  const [marketTypes, setMarketTypes] = useState([
    {
      value: 1,
      label: "Market Type 1",
    },
    {
      value: 2,
      label: "Market Type 2",
    },
  ]);
  const [statuses, setStatuses] = useState([
    {
      value: "cancelled",
      label: "Cancelled",
    },
    {
      value: "finalized",
      label: "Finalized",
    },
  ]);

  const getBetsReport = async (
    page = 1,
    refresh = false,
    queryString = todayRange,
    isQueryString = true,
    updateFilters = true
  ) => {
    let startDate = "";
    let endDate = "";

    if (isQueryString && queryString) {
      let formattedQueryString = queryString.split("&");
      startDate = dayjs(formattedQueryString[0]).format("YYYY-MM-DD");
      endDate = dayjs(formattedQueryString[1]).format("YYYY-MM-DD");
    } else if (queryString) {
      startDate = queryString[0]?.format("YYYY-MM-DD");
      endDate = queryString[1]?.format("YYYY-MM-DD");
    } else {
      startDate = null;
      endDate = null;
    }

    const cacheKey = page;

    if (betsCache[cacheKey] && !refresh) {
      const cached = betsCache[cacheKey];
      setBetsToShowInTable(cached.bets);
      setPagination(cached.pagination);
      return;
    }
    const params = {
      event_id: eventId,
      page: page,
      ...(startDate !== undefined && startDate !== null && { start_date: startDate }),
      ...(endDate !== undefined && endDate !== null && { end_date: endDate }),
      ...(selectedBetType !== undefined && selectedBetType !== null && { bet_type: selectedBetType }),
      ...(selectedStatus !== undefined && selectedStatus !== null && { status: selectedStatus }),
      ...(selectedMarketType !== undefined && selectedMarketType !== null && { market_type: selectedMarketType }),
    };

    console.log("params", params);
    try {
      setIsApiRunning(true);

      const request = [
        PrivateAdminPanelInstance?.post(
          API_ROUTES?.GET_EVENT_DETAILS_TABLE,
          params
        ),
        PrivateAdminPanelInstance?.post(API_ROUTES?.GET_EVENT_MARKETS, {
          event_id: eventId,
        }),
      ];

      const response = await Promise.allSettled(request);
      const [eventDetailsTableResponse, eventMarketsResponse] = response;
     
      if (eventDetailsTableResponse.status === "fulfilled") {
        const bets = eventDetailsTableResponse?.value?.data?.data?.bets || [];
        console.log("bets", bets);
        const paginationData =
          eventDetailsTableResponse?.value?.data?.data?.pagination;
        setBetsToShowInTable(bets);
        setPagination(paginationData);
        setBetsCache((prev) => ({
          ...prev,
          [cacheKey]: { bets, pagination: paginationData },
        }));
      }

      if (eventMarketsResponse.status === "fulfilled") {
        const markets = eventMarketsResponse?.value?.data?.data?.markets;
        console.log("markets", eventMarketsResponse?.value?.data?.data);
        const marketTypes = markets.map((market) => ({
          value: market.market_name,
          label: market.market_name,
        }));
        setMarketTypes(marketTypes);
      }
    } catch (error) {
      console.log("Error adding event code:", error);
    } finally {
      setIsApiRunning(false);
    }
  };

  const handlePaginationChange = (page) => {
    let queryStringParams = sportsBookDates;
    console.log("queryStringParams", queryStringParams);
    console.log(page)
    getBetsReport(page, false, queryStringParams, false, false);
  };

  const handleChangeBetId = (value) => {
    setSelectedBetId(value);
  };

  const handleBetTypeChange = (value) => {
    setSelectedBetType(value);
  };

  const handleMarketTypeChange = (value) => {
    setSelectedMarketType(value);
  };

  const handleStatusChange = (value) => {
    setSelectedStatus(value);
  };

  const handleApplyFilters = () => {
    getBetsReport(1, true, sportsBookDates, false, true);
  };

  const handleDateChange = (queryString) => {
    getBetsReport(1, true, queryString, true, false);
  };

  const handleBackToEventDetails = () => {
    navigate(-1);
  };

  useEffect(() => {
    getBetsReport(1, true, sportsBookDates, false, true);
  }, []);

  return (
    <>
      <div className="bets-types-list-container">
        <div className="bets-types-list">
          <>
            <div className="head-controls">
              <div className="header-text-container">
                <LeftOutlined
                  className="bets-types-list-header-back-button"
                  onClick={handleBackToEventDetails}
                />
              </div>
              <CustomDatePicker
                getData={handleDateChange}
                dates={sportsBookDates}
                setDates={setSportsBookDates}
                showPresets={true}
              />
            </div>
            <div className="bets-types-list-content">
              <div className="bets-types-list-content-header">
                <div className="bets-types-list-autocomplete-container">
                  <div className="bets-types-list-selectors">
                    <span className="bets-types-list-selectors-title">
                      {AppStrings.FILTER_BY}
                    </span>
                    <div className="divider"></div>
                    <div className="bets-types-list-selector">
                      <Select
                        placeholder={AppStrings.NOT_SELECTED}
                        value={selectedBetType}
                        onChange={(value) => handleBetTypeChange(value)}
                        options={betTypes}
                      />
                    </div>
                    <div className="bets-types-list-selector">
                      <Select
                        placeholder={AppStrings.MARKET_TYPE}
                        value={selectedMarketType}
                        onChange={(value) => handleMarketTypeChange(value)}
                        options={marketTypes}
                      />
                    </div>
                    <div className="bets-types-list-selector">
                      <Select
                        placeholder={AppStrings.STATUS}
                        value={selectedStatus}
                        onChange={(value) => handleStatusChange(value)}
                        options={statuses}
                      />
                    </div>
                    <div className="bets-types-list-selector-action-buttons">
                      <button
                        className="apply"
                        onClick={() => handleApplyFilters()}
                      >
                        {AppStrings.APPLY}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {isApiRunning ? (
                <RebetLoader height={"100px"} width={"100px"} />
              ) : (
                <div className="bets-types-list-kpis-table">
                  <DragAndDropTable
                    columns={columns}
                    data={betsToShowInTable}
                    mode="resize"
                  />
                  <div className="bets-types-list-pagination-container">
                    <Pagination
                      current={pagination.current_page}
                      total={pagination.total_results}
                      pageSize={pagination.page_size}
                      showSizeChanger={false}
                      onChange={(page) => {
                        if (
                          page === pagination.current_page - 1 ||
                          page === pagination.current_page + 1
                        ) {
                          handlePaginationChange(page);
                        }
                      }}
                      itemRender={(page, type, originalElement) => {
                        if (type === "page") {
                          return (
                            <a
                              rel="nofollow"
                              disabled={page > pagination.current_page + 1}
                              className={`${
                                page > pagination.current_page + 1
                                  ? "disabled"
                                  : ""
                              }`}
                            >
                              {page}
                            </a>
                          );
                        }
                        return originalElement;
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          </>
        </div>
      </div>
    </>
  );
}

export default BetsTypesList;
